export default "__VITE_ASSET__f5a32ada__"